module.exports = __webpack_public_path__ + "img/partenaire_MBA.da9af42c.png";